import { render, staticRenderFns } from "./VerificarWhatsapp.vue?vue&type=template&id=0decd9b4"
import script from "./VerificarWhatsapp.vue?vue&type=script&lang=js"
export * from "./VerificarWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports